import { useState } from 'react';
import { Nav } from 'react-bootstrap';
import { Info } from 'lucide-react';

const forumTabs = [
  "My Discussions",
  "My Replies",
  "My Favorites"
];

export default function ForumsSection() {
  const [activeTab, setActiveTab] = useState("My Discussions");

  const renderContent = () => {
    switch (activeTab) {
      case "My Discussions":
        return (
          <>
            <h5 className="mb-4">Forum Discussions Started</h5>
            <div className="d-flex align-items-center gap-2 text-muted">
              <div
                className="bg-primary rounded-circle p-2 d-flex align-items-center justify-content-center"
                style={{ width: '32px', height: '32px' }}
              >
                <Info size={16} className="text-white" />
              </div>
              <span>You have not created any discussions.</span>
            </div>
          </>
        );
      case "My Replies":
        return (
          <>
            <h5 className="mb-4">Forum Replies Created</h5>
            <div className="d-flex align-items-center gap-2 text-muted">
              <div
                className="bg-primary rounded-circle p-2 d-flex align-items-center justify-content-center"
                style={{ width: '32px', height: '32px' }}
              >
                <Info size={16} className="text-white" />
              </div>
              <span>You have not replied to any discussions.</span>
            </div>
          </>
        );
      case "My Favorites":
        return (
          <>
            <h5 className="mb-4">Forum Favorites</h5>
            <div className="d-flex align-items-center gap-2 text-muted">
              <div
                className="bg-primary rounded-circle p-2 d-flex align-items-center justify-content-center"
                style={{ width: '32px', height: '32px' }}
              >
                <Info size={16} className="text-white" />
              </div>
              <span>You have not favorited any discussions.</span>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div className="card shadow-sm">
      <div className="card-body p-0">
        <Nav className="border-bottom gap-4 px-4">
          {forumTabs.map((tab) => (
            <Nav.Item key={tab}>
              <Nav.Link
                onClick={() => setActiveTab(tab)}
                className={`py-3 px-1 border-bottom border-3 ${
                  activeTab === tab ? 'border-primary text-primary' : 'border-transparent text-muted'
                }`}
              >
                {tab}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
        
        <div className="p-4">
          {renderContent()}
        </div>
      </div>
      <div className="text-muted small p-3 border-top">
        © 2025 - TDTL LMS
      </div>
    </div>
  );
}
